import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CompanyService } from 'src/app/services/core/company/company.service';
import { ProductService } from 'src/app/services/core/services/product-services/product.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
import { sweetAlert } from 'src/app/utils/swal';

@UntilDestroy()

@Component({
  selector: 'app-product-service-list',
  templateUrl: './product-service-list.component.html',
  styleUrls: ['./product-service-list.component.css']
})
export class ProductServiceListComponent implements OnInit {
  numberOfRecords = NUMBER_OF_RECORDS;
  productItems: any = [];
  filteredProductItems:any;
  search: any
  selectedCompanyId = null;
  companies:any;
  currentPage: number = 1;
   totalPages = 0;
  totalResults = 0;
  loadingId = null;
  syncType = null;
  selectedDropdownId: any;
  toggleActionButtons = false;
  serviceDetail: any;

  constructor(
    private companyService : CompanyService,
    private productService: ProductService,
  ) { }

  ngOnInit() {
    this.getCompanies();
    this.getProductItems(this.currentPage);
    // this.getProductItems();
  }

  getProductItems(page:any) {
    this.productItems = [];
    let queryParams = {
      limit: 9999,
      page,
    }
    this.productService.getProductServices(queryParams)
      .pipe(untilDestroyed(this)).subscribe({
        next: (data: any) => {
          if (data) {
            this.productItems = data.results;
            this.filteredProductItems = [...this.productItems];
            this.totalPages = data.totalPages;
            this.totalResults = data.totalResults;
          }
        },
        error: (err) => {
          sweetAlert('Error', err, 'error', 'Ok');
        }
      })
  }

  getCompanies() {
    this.companyService.getCompanies().subscribe((data: any) => {
      if (data) {
        this.companies = data.results
        // this.preCompanies = data.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
      }
    })
  }

    filterProductServices() {
    if (this.selectedCompanyId) {
     this.filteredProductItems = this.productItems.filter((item: any) => {
      return item.company && item.company.id === this.selectedCompanyId;
    });
    } else {
      this.filteredProductItems = [...this.productItems];
    }
  }

   onPageChange(page: number) {
    this.currentPage = page;
    this.getProductItems(page);
  }

   async onSyncProductService(compamyId: any, serviceId:any, type: any) {
    const mPull = 'Are you sure you want to overwrite service data with QuickBooks data?';
    const mPush = 'Are you sure you want to overwrite the QuickBooks data with service data';
    const result = await sweetAlert('Alert', type === 'pull' ? mPull : mPush, 'warning', 'Yes', 'No');
    if (!result.value) return;

    this.loadingId = serviceId;
    this.syncType = type;
    const item = this.productItems?.find((s: any) => s.id === serviceId);
    if (item) {
      if (type === 'pull') item.pulling = true; else item.pushing = true;
    }
    this.closeActionMenu();
    this.productService.syncProductService(compamyId, serviceId, { isSyncFrom: type === 'pull' }).subscribe(
      {
      next: (data: any) => {
     this.getProductItems(this.currentPage);
     sweetAlert('Success', data?.message || 'Synced successfully', 'success', 'Ok');
    },
    error: (err) => {
      sweetAlert('Error', err, 'error', 'Ok');
      if (item) {
        item.pulling = false;
        item.pushing = false;
      }
    },
    complete: () => {
      this.loadingId = null;
      this.syncType = null;
      if (item) {
        item.pulling = false;
        item.pushing = false;
      }
    }
    })
  }

  opendetailModal(item: any) {
    this.serviceDetail = item;
  }

  showActionButtons(id: any) {
    this.selectedDropdownId = id;
    this.toggleActionButtons = true;
  }

  closeActionMenu(_event?: any) {
    this.selectedDropdownId = null;
    this.toggleActionButtons = false;
  }

}
